import { render } from "./FullTextSearch.vue?vue&type=template&id=27194fea"
import script from "./FullTextSearch.vue?vue&type=script&lang=js"
export * from "./FullTextSearch.vue?vue&type=script&lang=js"

import "./FullTextSearch.vue?vue&type=style&index=0&id=27194fea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__